import React from 'react';

/**
 * CoworkerSlotBadge — Phase 10c.
 *
 * Tiny sub-badge rendered alongside the canonical `#{queue_number}`
 * chip when the visit is surfaced on the viewer's lane via the
 * co-worker projection (`is_co_worker_visit === true`). Shows the
 * private lane position from `coworker_queue_position` so the doctor
 * has a stable scan order without polluting the org-wide number that
 * receptionist and patient see.
 *
 * Renders nothing when either flag/value is absent — safe to drop in
 * everywhere.
 */
export default function CoworkerSlotBadge({ visit, className = '' }) {
  if (!visit?.is_co_worker_visit) return null;
  const pos = visit.coworker_queue_position;
  if (!pos) return null;

  return (
    <span
      title="Your private queue position"
      className={[
        'inline-flex items-center text-[10px] font-medium px-1.5 py-0.5 rounded',
        'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300',
        'border border-slate-300 dark:border-slate-600',
        className,
      ].join(' ')}
    >
      your slot #{pos}
    </span>
  );
}
